import { Plugin, Store } from "vuex";
import axios from "axios";
import { IStaticDataLoadingStatus, IStaticDataUpdate, IStoreStaticData } from "./staticdata.types";

const dataApiUrl = process.env.VUE_APP_DATA_API_URL || "https://data.mahetec.info/nodered";

const StaticDataStorePlugin: Plugin<any> = (store: Store<{ staticdata: IStoreStaticData}>) => {
  // NASA TV Schedule
  store.subscribeAction((action) => {
    let metadata: IStaticDataUpdate = {} as IStaticDataUpdate;

    switch (action.type) {
      case "staticdata/updateNASATVSchedule":
        metadata = {
          name: "nasatvschedule",
          url: "/nasa/nasatv-schedule",
          identifier: "NASATVSCHEDULE"
        }
        break;

      case "staticdata/updateSpaceStationBlog":
        metadata = {
          name: "spacestationblog",
          url: "/nasa/blogs?name=spacestation",
          identifier: "SPACESTATIONBLOG"
        }
        break;
        
      case "staticdata/updateStreams":
        metadata = {
          name: "streams",
          url: "/nasa/streams",
          identifier: "STREAMS"
        }
        break;

      case "staticdata/updateLiveEvents":
        metadata = {
          name: "liveevents",
          url: "/nasa/liveevents",
          identifier: "LIVEEVENTS"
        }
        break;

      case "staticdata/updateCountdowns":
        metadata = {
          name: "countdowns",
          url: "/nasa/countdowns",
          identifier: "COUNTDOWNS",
          timeout: 30 * 1000 // 30 sec
        }
        break;

      default:
        break;
    }

    if (
      metadata.identifier &&
      store.state.staticdata[metadata.name].status !== "loading" &&
      (Date.now() - store.state.staticdata[metadata.name].timestamp.getTime()) > (metadata.timeout ||  5 * 60 * 1000) // 5mins
    ) {
      store.commit(`staticdata/UPDATE_${metadata.identifier}_STATUS`, "loading" as IStaticDataLoadingStatus)
      axios.get(`${dataApiUrl}${metadata.url}`)
      .then((res) => {
        store.commit(`staticdata/UPDATE_${metadata.identifier}`, {
          timestamp: new Date(res.data.timestamp || 0),
          status: "ok",
          content: res.data
        })
      })
      .catch((err) => {
        console.error(err)
        store.commit(`staticdata/UPDATE_${metadata.identifier}_STATUS`, "error" as IStaticDataLoadingStatus)
        })
    }
  })
}

export default StaticDataStorePlugin;